import * as Sentry from '@sentry/angular';

// Plain object wrapper so tests can spy on these.
// @sentry/angular v8 uses ESM-only exports that are non-configurable,
// making spyOn / Object.defineProperty impossible to use in Jasmine tests.
export const sentryHelper = {
  captureException: (error: any, context?: any) =>
    Sentry.captureException(error, context),
  addBreadcrumb: (breadcrumb: any) => Sentry.addBreadcrumb(breadcrumb)
};

// Angular reports a request the browser never completed as status 0: the tab
// was closed or navigated away mid-flight, or the connection dropped. For the
// static files under /assets/ that is a client-side condition we can neither
// fix nor act on, and it produced thousands of unactionable Sentry issues
// (VITAY-FRONTEND-Q3, -QP, -WD, -WF).
//
// A genuine problem with an asset — a deploy that dropped the file — arrives
// as a 404, so those stay reportable on purpose.
export const isAbortedAssetRequest = (error: any): boolean => {
  if (!error || error.name !== 'HttpErrorResponse' || error.status !== 0) {
    return false;
  }

  return /(^|\/)assets\//.test(String(error.url || ''));
};

// Single reporting policy for the static assets we load at bootstrap, so a
// browser abort leaves a breadcrumb while anything else still pages us.
export const reportAssetLoadFailure = (error: any, url: string): void => {
  if (isAbortedAssetRequest(error)) {
    sentryHelper.addBreadcrumb({
      category: 'http',
      level: 'warning',
      message: `Asset request did not complete: ${url}`,
      data: { url, status: 0 }
    });

    return;
  }

  sentryHelper.captureException(error, {
    tags: { component: 'AssetLoad' },
    extra: {
      url,
      error_message: error && error.message,
      error_status: error && error.status
    }
  });
};
